module.exports = __webpack_public_path__ + "media/images/pages/team-2-1972d8ad5b41ad42b00ccb3febbe40ac.jpg";